import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import ToolsMyPickupsInUsePage from './ToolsMyPickupsInUsePage';
import ToolsMyPickupsHistoryPage from './ToolsMyPickupsHistoryPage';
import { toolCheckoutsRestCrudThunksForSupplier } from '../../thunks/tool_checkouts_thunks';
import { updateFiltersEntities } from '../../thunks/thunks_wrapper';
import { ROLE_TYPES } from '../../utils/DataConstants';

const IN_USE_COLLECTION = 'myPickupsInUseIndex';
const HISTORY_COLLECTION = 'myPickupsHistoryIndex';

const TABS = [
	{ key: 'inUse', label: 'In Use', collection: IN_USE_COLLECTION },
	{ key: 'history', label: 'History', collection: HISTORY_COLLECTION },
];

const ToolsMyPickupsPage: FC<any> = ({ updateSearchFilter, history }): React.ReactElement => {
	const [activeTab, setActiveTab] = useState('inUse');
	const [searchByTab, setSearchByTab] = useState({ inUse: '', history: '' });
	const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

	const handleTabClick = useCallback((key) => {
		setActiveTab(key);
	}, []);

	const activeCollection = useMemo(
		() => TABS.find((tab) => tab.key === activeTab).collection,
		[activeTab]
	);

	const currentSearch = searchByTab[activeTab];

	const handleSearchChange = useCallback(
		(event) => {
			const value = event.target.value;
			setSearchByTab((prev) => ({ ...prev, [activeTab]: value }));

			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
			debounceTimer.current = setTimeout(() => {
				updateSearchFilter(activeCollection, value, history);
			}, 400);
		},
		[activeTab, activeCollection, updateSearchFilter, history]
	);

	useEffect(() => {
		return () => {
			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
		};
	}, []);

	return (
		<div className="pl-4">
			<div className="flex items-end  gap-4 border-0 border-b border-solid border-grey-3">
				<div className="flex">
					{TABS.map((tab) => {
						const isActive = activeTab === tab.key;
						return (
							<button
								key={tab.key}
								type="button"
								onClick={() => handleTabClick(tab.key)}
								className={
									'bodymedium relative -mb-px cursor-pointer border-0 border-b-2 border-solid bg-transparent px-4 py-3 ' +
									(isActive
										? 'border-supplier text-supplier'
										: 'border-transparent text-character-secondary')
								}
							>
								{tab.label}
							</button>
						);
					})}
				</div>
				<div className="w-72">
					<Input
						allowClear
						value={currentSearch}
						onChange={handleSearchChange}
						placeholder="Search text"
						prefix={<SearchOutlined className="text-character-secondary" />}
					/>
				</div>
			</div>
			<div>
				{activeTab === 'inUse' && <ToolsMyPickupsInUsePage />}
				{activeTab === 'history' && <ToolsMyPickupsHistoryPage />}
			</div>
		</div>
	);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	updateSearchFilter: (targetCollectionName, search, history) =>
		dispatch(
			updateFiltersEntities(
				ROLE_TYPES.SUPPLIER,
				'tool_checkouts',
				toolCheckoutsRestCrudThunksForSupplier,
				null
			)(null, history, targetCollectionName, { search: search ? search.trim() : undefined }, true)
		),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ToolsMyPickupsPage));
